/**************************** IMAGE UPLOAD ***************************************/
$( function() {
  $( "#CustomJacket" ).accordion({
    collapsible: true,
    heightStyle: "content"
  });
});
$(".gsrtd.btn").on('click',function() {
  $('html, body').animate({
    'scrollTop' : $(".PlusCustomForm").position().top
  });
});
$("#countries").msDropdown();
$(".DenImageForm").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.DenImageForm').prop('files')[0];
    var imageName = $('.DenImageForm').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.DenImageForm').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/images/"+ne_get_1 ;
    var formData = new FormData($("#Dencustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#Dencustom_form #Denbar").show();
            $("#Dencustom_form #Denbar").text("("+percentComplete+"%)");
            $("#Dencustom_form .Denbar_wrapper_1").show();
            $("#Dencustom_form .DenimageWrapp").css("display","none");
            $("#Dencustom_form .Denmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("Denbar").style.width=percentComplete+'%';
            document.getElementById("Denbar").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#Dencustom_form .DenimageWrapp").css("display","none");
              $("#Dencustom_form .Denmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#Dencustom_form .Denbar_wrapper_1.Denprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#Dencustom_form .DenImageForm").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#Dencustom_form").hide();
        $(".DenImagesNames").html("<span>"+imageName+",</span>");
        $("#Dencustom_form_2").show();
      }
    })
  }
})

/************** 2nd Image ********************************/
$(".DenImageForm_2").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.DenImageForm_2').prop('files')[0];
    var imageName = $('.DenImageForm_2').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.DenImageForm_2').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/images/"+ne_get_1 ;
    var formData = new FormData($("#custom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#Dencustom_form_2 #Denbar_2").show();
            $("#Dencustom_form_2 #Denbar_2").text("("+percentComplete+"%)");
            $("#Dencustom_form_2 .Denbar_wrapper_1").show();
            $("#Dencustom_form_2 .DenimageWrapp").css("display","none");
            $("#Dencustom_form_2 .Denmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("Denbar_2").style.width=percentComplete+'%';
            document.getElementById("Denbar_2").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#Dencustom_form_2 .DenimageWrapp").css("display","none");
              $("#Dencustom_form_2 .Denmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#Dencustom_form_2 .Denbar_wrapper_1.Denprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#Dencustom_form_2 .DenImageForm_2").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#Dencustom_form_2").hide();
        $("<span>"+imageName+",</span>").appendTo(".DenImagesNames");
        $("#Dencustom_form_3").show();
      }
    })
  }
})   

/************** 3rd Image ********************************/
$(".DenImageForm_3").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.DenImageForm_3').prop('files')[0];
    var imageName = $('.DenImageForm_3').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.DenImageForm_3').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/images/"+ne_get_1 ;
    var formData = new FormData($("#Dencustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#Dencustom_form_3 #Denbar_3").show();
            $("#Dencustom_form_3 #Denbar_3").text("("+percentComplete+"%)");
            $("#Dencustom_form_3 .Denbar_wrapper_1").show();
            $("#Dencustom_form_3 .DenimageWrapp").css("display","none");
            $("#Dencustom_form_3 .Denmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("Denbar_3").style.width=percentComplete+'%';
            document.getElementById("Denbar_3").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#Dencustom_form_3 .DenimageWrapp").css("display","none");
              $("#Dencustom_form_3 .Denmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#Dencustom_form_3 .Denbar_wrapper_1.Denprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#Dencustom_form_3 .DenImageForm_3").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#Dencustom_form_3").hide();
        $("<span>"+imageName+",</span>").appendTo(".DenImagesNames");
        $("#Dencustom_form_4").show();
      }
    })
  }
})

/************** 4th Image ********************************/
$(".DenImageForm_4").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.DenImageForm_4').prop('files')[0];
    var imageName = $('.DenImageForm_4').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.DenImageForm_4').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/images/"+ne_get_1 ;
    var formData = new FormData($("#Dencustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#Dencustom_form_4 #Denbar_4").show();
            $("#Dencustom_form_4 #Denbar_4").text("("+percentComplete+"%)");
            $("#Dencustom_form_4 .Denbar_wrapper_1").show();
            $("#Dencustom_form_4 .DenimageWrapp").css("display","none");
            $("#Dencustom_form_4 .Denmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("Denbar_4").style.width=percentComplete+'%';
            document.getElementById("Denbar_4").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#Dencustom_form_4 .DenimageWrapp").css("display","none");
              $("#Dencustom_form_4 .Denmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#Dencustom_form_4 .Denbar_wrapper_1.Denprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#Dencustom_form_4 .DenImageForm_4").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#Dencustom_form_4").hide();
        $("<span>"+imageName+",</span>").appendTo(".DenImagesNames");
        $("#Dencustom_form_5").show();
      }
    })
  }
})

/************** 5th Image ********************************/
$(".DenImageForm_5").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.DenImageForm_5').prop('files')[0];
    var imageName = $('.DenImageForm_5').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.DenImageForm_5').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/images/"+ne_get_1 ;
    var formData = new FormData($("#Dencustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#Dencustom_form_5 #Denbar_5").show();
            $("#Dencustom_form_5 #Denbar_5").text("("+percentComplete+"%)");
            $("#Dencustom_form_5 .Denbar_wrapper_1").show();
            $("#Dencustom_form_5 .DenimageWrapp").css("display","none");
            $("#Dencustom_form_5 .Denmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("Denbar_5").style.width=percentComplete+'%';
            document.getElementById("Denbar_5").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#Dencustom_form_5 .DenimageWrapp").css("display","none");
              $("#Dencustom_form_5 .Denmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#Dencustom_form_5 .Denbar_wrapper_1.Denprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#Dencustom_form_5 .DenImageForm_5").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        $("<span>"+imageName+"</span>").appendTo(".DenImagesNames");
        console.log("RIGHT SUBMIT");
        $("#Dencustom_form_5").addClass("StopUpload");
      }
    })
  }
})


/****************FORM SUBMIT *********************/
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var OrderId = getCookie("OrderId");
$(".hdrbg h3 b").html(OrderId);
$(".DenbtnGtsrtd button.form-btn.btn.btn-default").click(function(){

  var nameGet = $(".DenNameForm").val();
  var emailGet = $(".DenEmailForm").val();
  var numberGet = $(".DenNumberForm").val();
  var selectGet = $("#countries").val();
  var ImageGet = $(".DenImageForm").attr("data-src");
  var ImageGet_2 = $(".DenImageForm_2").attr("data-src");
  var ImageGet_3 = $(".DenImageForm_3").attr("data-src");
  var ImageGet_4 = $(".DenImageForm_4").attr("data-src");
  var ImageGet_5 = $(".DenImageForm_5").attr("data-src");
  var DescriptionGet = $(".DenDescriptionForm").val();


  validateEmail(emailGet);


  function validateEmail(email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if (!emailReg.test(email)) {
      $("input.form-control.DenEmailForm").css("border","1px solid red");
    }
    else if((emailGet=='')&&(nameGet=='')){
      $("input.form-control.DenEmailForm").css("border","1px solid red");
      $("input.form-control.DenNameForm").css("border","1px solid red");
    }
    else if((emailGet=='')||(nameGet=='')){

      if(emailGet==''){
        $("input.form-control.DenEmailForm").css("border","1px solid red");
      }
      else{
        $("input.form-control.DenNameForm").css("border","1px solid red");
      }
    }

    else { 

      $(".RightWrap button.form-btn.btn.btn-default").addClass("LoaderForm");
      var OrderId = Math.floor((Math.random() * 10000000) + 1);
      $("input.form-control.DenEmailForm").css("border","1px solid #cccccc");
      $("input.form-control.DenNameForm").css("border","1px solid #cccccc");
      setCookie("OrderId", OrderId, 365);
      $.ajax({
        type: 'POST',
        url: 'http://deluxeplumbers.com/leathershopify/postmarkapp/src/custom-denim.php',
        data: {ImageGet:(ImageGet),ImageGet_2:(ImageGet_2),ImageGet_3:(ImageGet_3),ImageGet_4:(ImageGet_4),ImageGet_5:(ImageGet_5),OrderId:(OrderId),name:(nameGet),email:(emailGet),phone_number:(numberGet),want_to_make:(selectGet),description:(DescriptionGet)},
        dataType: 'html',
        success: function(response){
            
          window.location.href = "/pages/thank-you" ;
          var OrderId = getCookie("OrderId");
          $(".hdrbg h3 b").html(OrderId);
        }
      })
    }
  }

})